<div (click)="navigate()" class="ion-padding">
  <div class="smlistitem-image"
    [ngStyle]="{'background-image': 'url(' + safeURL(basepath+'storage/app/media'+b.image) + ')'}">
    <ion-icon *ngIf="isboxVisited()" src="/assets/custom-ion-icons/check-mark.svg"></ion-icon>
  </div>
  <p class="link-button" expand="full" [innerHTML]="b.title"></p>
  <ion-icon class="right-chevron" src="/assets/custom-ion-icons/custom-chevron.svg"></ion-icon>
  <!-- <img [src]="basepath+'storage/app/media'+b.image" alt=""> -->
</div>